import cookie from 'js-cookie';
class CsrfToken {
    static refresh() {
        let t = Number(cookie.get('token.lifetime')) * 60 * 1000 / 2 || 60 * 1000;
        setTimeout((endpoint) => {
            window.axios
                .get(endpoint, {})
                .then(response => {
                let data = response.data;
                let tokens;
                tokens = document.head.querySelectorAll('meta[name="csrf-token"]');
                tokens.forEach((token) => {
                    token.setAttribute('content', data.csrf_token);
                });
                tokens = document.body.querySelectorAll('input[name="_token"]');
                tokens.forEach((token) => {
                    token.setAttribute('value', data.csrf_token);
                });
                this.refresh();
            });
        }, t, this.endpoint_refresh);
    }
}
CsrfToken.endpoint_refresh = '/csrf/refresh';
window.addEventListener("load", (e) => {
    CsrfToken.refresh();
});
